import { markActionAsHandled } from 'Modules/errors/services/actionMarker';

import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  isLoading: false,
  error: null,
};

export function signUp(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.POST_CREATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case actionTypes.POST_CREATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case actionTypes.POST_CREATE_USER_FAILURE:
      markActionAsHandled(action);
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default signUp;
